import React, { Dispatch, SetStateAction, useEffect } from 'react';

import { Box, Grid, MenuItem, Select, SelectChangeEvent } from '@mui/material';
import { CustomizableSwitch } from './CustomizableSwitch';

export interface GroupByAttribute<I, O> {
  id: string;
  displayValue: string;
  groupByPath: (resultRow: O, ...rowData: I[]) => O;
  groupingColumnDef: () => any;
  show: boolean;
}

export type SampleTrackingGroupByAttributesProps<I, O> = {
  enabled: boolean;
  setEnabled: Dispatch<SetStateAction<boolean>>;
  items: GroupByAttribute<I, O>[];
  selectedId: string;
  setSelectedId: Dispatch<SetStateAction<string>>;
};

export const SampleTrackingGroupByAttributes = <I, O>({
  enabled,
  setEnabled,
  items,
  selectedId,
  setSelectedId,
}: SampleTrackingGroupByAttributesProps<I, O>) => {
  const handleSelectionChange = (event: SelectChangeEvent<string>) => {
    setSelectedId(event.target.value as string);
  };

  useEffect(() => {
    if (!selectedId && items.length > 0) {
      setSelectedId(items[0].id);
    }
  }, [setSelectedId, selectedId, items]);

  return items.length > 0 ? (
    <Box display={'flex'}>
      <Grid container spacing={2} alignItems={'center'}>
        <Grid item textAlign={'left'}>
          <CustomizableSwitch
            key={'groupBy'}
            title={'Group By'}
            checked={enabled}
            onChange={() => {
              setEnabled(!enabled);
            }}
          />
        </Grid>
        <Grid item>
          <Select<string>
            value={selectedId}
            onChange={handleSelectionChange}
            disabled={!enabled}
            size='small'
            id={'groupBySelect'}
          >
            {items
              .filter(item => item.show)
              .map(item => (
                <MenuItem key={item.id} value={item.id}>
                  {item.displayValue}
                </MenuItem>
              ))}
          </Select>
        </Grid>
      </Grid>
    </Box>
  ) : null;
};
